module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon6.d1bfa7b5.png";